var React = require('react');

function BannerBand (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#F2F2F2","d":"M1440,0.01c-109,41.11-396.34,70-724.2,70C388.94,70,109.67,40.93,0,0h1440V0.01z"}));
}

BannerBand.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 1440 70","enableBackground":"new 0 0 1440 70","xmlSpace":"preserve","preserveAspectRatio":"none"};

module.exports = BannerBand;

BannerBand.default = BannerBand;
